/**
 * タイムセールマスタ設定画面Input用VOクラス
 */
export class KYMW6501InputModel {
  public static PROCES_DIV_REGIST: string = <string>'1';                        // 処理区分(登録)
  public static PROCES_DIV_UPDATE: string = <string>'2';                        // 処理区分(更新)
  public static PROCES_DIV_DELETE: string = <string>'3';                        // 処理区分(削除)

  public ProcesDiv: string = <string>'';                                        // 処理区分
  public OrderCode: string = <string>'';                                        // 受注コード
  public CategoryCode: string = <string>'';                                     // カテゴリコード
}
